import { WebLink } from '@news-mono/web-common'
import React from 'react'
import { Breakpoints } from '../../__styling/settings/breakpoints'
import { ThemeMargins } from '../../__styling/settings/metrics'
import { breakpoint as caclBreakpoint } from '../../__styling/style-functions'
import { StyledPicture } from './ImageBanner.styled'

interface Source {
    src:
        | string
        | {
              src: string
              density: '2x' | '1x'
          }[]
    breakpoint?: keyof Breakpoints
}

export interface ImageBannerProps {
    verticalGutters?: [keyof ThemeMargins, keyof ThemeMargins]
    defaultSrc: string
    altText: string
    sources?: Source[]
    url?: string
    forceInternalSSR?: boolean
    hiddenHeading?: string
}

export const ImageBanner: React.FC<ImageBannerProps> = ({
    defaultSrc,
    altText,
    sources,
    verticalGutters,
    url,
    forceInternalSSR,
    hiddenHeading,
}) => {
    const renderImage = (
        <h1 style={{ margin: 0 }}>
            <StyledPicture verticalGutters={verticalGutters}>
                {sources &&
                    sources.map(({ src, breakpoint }, index) => {
                        const srcProps =
                            typeof src === 'string'
                                ? { srcSet: src }
                                : {
                                      srcSet: src
                                          .map(
                                              (src) =>
                                                  `${src.src} ${src.density}`,
                                          )
                                          .join(','),
                                  }

                        return (
                            <source
                                key={index}
                                media={
                                    breakpoint
                                        ? caclBreakpoint(breakpoint, false)
                                        : undefined
                                }
                                {...srcProps}
                            />
                        )
                    })}
                <img src={defaultSrc} alt={hiddenHeading || altText} />
            </StyledPicture>
            <span hidden>{hiddenHeading}</span>
        </h1>
    )

    return url ? (
        <WebLink to={url} forceInternalSSR={forceInternalSSR}>
            {renderImage}
        </WebLink>
    ) : (
        renderImage
    )
}
ImageBanner.displayName = 'ImageBanner'
